import Grid from "@mui/material/Grid";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import React, { ReactNode } from "react";
import { useCommunicationMedium } from "./CommunicationMediumProvider";
import { getCommunicationMedium } from "./communicationHelperFunctions";
import { SelectChangeEvent } from "@mui/material";
import { useCase } from "../../../provider/CaseProvider";

export default function SendForm({ children }: { children: ReactNode }) {
  const {
    recipientType,
    setRecipientType,
    recipientMenuItems,
    communicationMedium,
    setCommunicationMedium,
    communicationMediumEditable,
  } = useCommunicationMedium();

  const { product } = useCase();

  const handleRecipientTypeChange = (event: SelectChangeEvent) => {
    if (!product) {
      return;
    }
    setCommunicationMedium(getCommunicationMedium(product, event.target.value));
    setRecipientType(event.target.value);
  };

  return (
    <Grid container columnSpacing={2}>
      <Grid size={6}>
        <ValidatorSelect
          label={"Empfänger"}
          name={"recipientType"}
          value={recipientType}
          onChange={handleRecipientTypeChange}
        >
          {recipientMenuItems}
        </ValidatorSelect>
      </Grid>
      <Grid size={6}>
        <ValidatorSelect
          label={"Versand per"}
          name={"communicationMedium"}
          disabled={!communicationMediumEditable}
          value={communicationMedium}
          onChange={(event) => setCommunicationMedium(event.target.value)}
        >
          <MenuItem value={"bea"}>per beA</MenuItem>
          <MenuItem value={"fax"}>per Fax</MenuItem>
        </ValidatorSelect>
      </Grid>
      {children}
    </Grid>
  );
}
